import React from "react";
import { Item } from "./Yuyue";
import styles from "../css/Yuyue.css";
import { Header } from "./Introduce";
import { Button, Toast } from "antd-mobile";
import { request } from "../request";
import {
  checkPhone,
  checkNum,
  checkZE,
  showAlert2,
} from "../tools/wechatBrower";

export function getId(name) {
  return document.getElementById(name)
    ? document.getElementById(name).value
    : "";
}

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        info: [],
        default: {},
      },
      name: "",
      phone: "",
      loading: false,
    };
  }

  componentDidMount() {
    this.init();
  }

  init() {
    request(
      "index/getReceiving",
      {
        uid: localStorage.getItem("openid"),
        // uid: "o3KXx5lSukpaX5Lwn_JRTiW5R_hk", // localStorage.getItem("openid"),
      },
      ({ data }) => {
        if (data) {
          this.setState(
            {
              data: data.data,
            },
            () => {
              console.log(this.state);
            }
          );
        }
      }
    );

    this.setState({
      model: this.props.match.params.model,
    });
  }

  main() {
    console.log(this.state.data.info);
    switch (this.state.model) {
      case "add":
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <div className={styles.info}>
              <div className={styles.head}>
                <span className={styles.title}>收件信息</span>
              </div>
              <Item
                left="* 标签"
                rightP="收件标签"
                // value={"12312"}
                id="tag"
              ></Item>
              <Item
                left="* 姓名"
                rightP="请输入姓名"
                id="name"
                value={this.state.name}
                onChange={(e) => {
                  this.state.name = e;
                  this.setState();
                }}
                onBlur={(e) => {
                  let is_phone = checkZE(this.getId("name"));
                  if (!is_phone) {
                    Toast.fail("姓名只允许中英文,最多二十个字");
                    return;
                  }
                }}
              ></Item>
              <Item
                left="* 联系电话"
                rightP="请输入联系电话"
                // value={"12312"}
                id="phone"
                value={this.state.phone}
                onChange={(e) => {
                  if (checkNum(e)) {
                    this.state.phone = e;
                    this.setState();
                  }
                }}
                onBlur={(e) => {
                  let is_phone = checkPhone(this.state.phone);
                  if (!is_phone) {
                    Toast.fail("手机号格式不正确");
                    return;
                  }
                }}
              ></Item>
              <Item
                left="* 收件地址"
                rightP="请输入收件地址"
                id="address"
                onBlur={(e) => {
                  if (getId("address").length > 100) {
                    Toast.fail("收件地址最多100个字符");
                    return;
                  }
                }}
              ></Item>
            </div>
          </div>
        );

      case "list":
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            {this.state.data.info.map(
              (element, index) =>
                element.hide !== "1" && (
                  <div className={styles.info}>
                    <div className={styles.head}>
                      <span className={styles.title}>收件信息</span>
                    </div>
                    <Item
                      left="标签"
                      rightP="用于识别唯一收件信息"
                      value={element.tag}
                      id="tag"
                      disabled={true}
                    ></Item>
                    <Item
                      left="姓名"
                      rightP="请输入姓名"
                      value={element.name}
                      disabled={true}
                    ></Item>
                    <Item
                      left="联系电话"
                      rightP="请输入联系电话"
                      value={element.phone}
                      disabled={true}
                    ></Item>
                    <Item
                      left="收件地址"
                      rightP="请输入收件地址"
                      value={element.address}
                      disabled={true}
                    ></Item>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        borderTop: "solid 1px #999999",
                        height: "25px",
                        alignItems: "flex-end",
                        marginTop: "10px",
                      }}
                    >
                      {/* <div>
                        <input
                          type="radio"
                          name="moren"
                          value={element.id}
                          checked={
                            element.id === this.state.data.default.receiving_id
                          }
                          onChange={(e) => {
                            request(
                              "index/changeDefaultR",
                              {
                                uid: localStorage.getItem("openid"),
                                // uid: "o3KXx5lSukpaX5Lwn_JRTiW5R_hk", // localStorage.getItem("openid"),
                                receiving_id: element.id,
                              },
                              ({ data }) => {
                                console.log(data);
                                if (data.code === 1) {
                                  Toast.info("成功");
                                  // eslint-disable-next-line
                                  this.state.data.default.receiving_id =
                                    element.id;
                                  this.setState({
                                    data: this.state.data,
                                  });
                                }
                              }
                            );
                          }}
                        />
                        <span
                          style={{
                            fontSize: "14px",
                            color: "rgb(174, 92, 201)",
                            marginRight: "5px",
                          }}
                        >
                          默认
                        </span>
                      </div> */}
                      <span
                        style={{
                          fontSize: "14px",
                          color: "rgb(174, 92, 201)",
                        }}
                        onClick={() => {
                          this.props.history.push(
                            "/ReceivingInformationEdit/" + element.id
                          );
                        }}
                      >
                        修改
                      </span>
                      <span
                        style={{
                          fontSize: "14px",
                          color: "rgb(174, 92, 201)",
                        }}
                        onClick={() => {
                          showAlert2({
                            content: "删除后不可以修复，请问确认删除吗？",
                            cancelFunc: () => {},
                            enterFunc: () => {
                              let that = this;
                              that.setState({
                                loading: true,
                              });

                              request(
                                "index/deleteReceiving",
                                {
                                  uid: localStorage.getItem("openid"),
                                  id: element.id, // localStorage.getItem("openid"),
                                },
                                ({ data }) => {
                                  console.log(data);
                                  if (data.code === 1) {
                                    // Toast.success("删除成功");

                                    that.state.data.info[index]["hide"] = "1";
                                    // that.setState();

                                    delete that.state.data.info[index];
                                    that.setState();
                                    // eslint-disable-next-line
                                    // this.state.data.default.receiving_id = element.id;
                                  } else {
                                    Toast.fail(data.msg);
                                  }
                                }
                              );
                            },
                          });
                        }}
                      >
                        删除
                      </span>
                    </div>
                  </div>
                )
            )}
          </div>
        );

      default:
        return <div></div>;
    }
  }

  sumbit() {
    if (this.state.model === "list") {
      return (
        <div
          style={{
            position: "fixed",
            height: "70px",
            left: 0,
            bottom: 0,
            right: 0,
            // backgroundColor: "rgb(51 51 51 / 14%)",
            display: "flex",
            maxWidth: "375px",
            margin: "auto",
          }}
        >
          <Button
            type="primary"
            style={{
              width: "88%",
              backgroundColor: "#AE5CC9",
              borderRadius: "23px",
              border: "1px solid #AE5CC9",
              margin: "auto",
            }}
            onClick={() => {
              if (this.state.data.info.length < 3) {
                this.setState({
                  model: "add",
                });
                this.props.history.push("/receivingAdd");
              } else {
                Toast.info("最多创建3个");
              }
            }}
          >
            添加收件信息
          </Button>
        </div>
      );
    }
  }

  render() {
    return (
      <div>
        <Header text="收件信息"></Header>
        {this.main()}
        <div style={{ height: "80px", width: "100%" }}></div>

        {this.sumbit()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ReceivingInformation.js